<div *ngIf="productDesc" class="product-desc-container">
  <p class="product-description" [innerHTML]="productDesc.description"></p>
</div>
